export default "__VITE_ASSET__C6o0hk96__"